import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { store } from "./store/store"; // ✅ your Redux store

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}> 
      <HelmetProvider>      
        <App />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);
